import './moodybibleinst/style';
import FormStructure from './moodybibleinst/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js